import React from "react";

import BernardClaustro from "../../../assets/images/directors/bernard-claustro.png";
import AlShawidIsmael from "../../../assets/images/directors/dl-ismael.png";
import JosefSoriano from "../../../assets/images/directors/josef-soriano.png";
import KathrynSorianoPosadas from "../../../assets/images/directors/kathryn-soriano-posadas.png";
import LeaSoriano from "../../../assets/images/directors/lea-soriano.png";
import MerlitaPrimo from "../../../assets/images/directors/merlita-primo.png";
import ReneSoriano from "../../../assets/images/directors/rene-soriano.png";
import ReynatoPrimo from "../../../assets/images/directors/reynato-primo.png";
import RolaidaPua from "../../../assets/images/directors/rolaida-pua.png";

const BoardOfDirectors = () => {
  return (
    <div id='chartListContainer'>
      <ul className='main-list'>
        <li className='list-item main'>
          <div className='image-container'>
            <img src={ReneSoriano} alt='rene-soriano' />
          </div>
          <div className='text-container'>
            <div className='name'>Rene Y. Soriano</div>
            <div className='title'>Chairman</div>
          </div>
        </li>
      </ul>
      <ul className='sub-list'>
        <li className='list-item'>
          <div className='image-container'>
            <img src={LeaSoriano} alt='lea-soriano' />
          </div>
          <div className='text-container'>
            <div className='name'>Lea S. Soriano</div>
            <div className='title'>President / Director</div>
          </div>
        </li>
        <li className='list-item'>
          <div className='image-container'>
            <img src={KathrynSorianoPosadas} alt='kathryn-soriano-posadas' />
          </div>
          <div className='text-container'>
            <div className='name'>Kathryn Leia S. Soriano-Posadas</div>
            <div className='title'>
              Vice President / Corporate Secretary
            </div>
          </div>
        </li>
        <li className='list-item'>
          <div className='image-container'>
            <img src={BernardClaustro} alt='bernard-claustro' />
          </div>
          <div className='text-container'>
            <div className='name'>Bernard Philip C. Claustro</div>
            <div className='title'>Director</div>
          </div>
        </li>
        <li className='list-item'>
          <div className='image-container'>
            <img src={MerlitaPrimo} alt='merlita-primo' />
          </div>
          <div className='text-container'>
            <div className='name'>Merlita M. Primo</div>
            <div className='title'>Director</div>
          </div>
        </li>
        <li className='list-item'>
          <div className='image-container'>
            <img src={JosefSoriano} alt='josef-soriano' />
          </div>
          <div className='text-container'>
            <div className='name'>Josef Ryan S. Soriano</div>
            <div className='title'>Director / Treasurer</div>
          </div>
        </li>
        <li className='list-item'>
          <div className='image-container'>
            <img src={ReynatoPrimo} alt='reynato-primo' />
          </div>
          <div className='text-container'>
            <div className='name'>Reynato J. Primo</div>
            <div className='title'>Independent Director</div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default BoardOfDirectors;
